<template>
  <div class="faq-page">
    <div class="banner">
      <img :src="cover" alt="banner" />
      <div class="banner-overlay">
        <div class="banner-content">
          <p class="banner-title">Frequently Asked Questions</p>
          <p class="banner-subtitle">Find answers to common questions about ordering, shipping, and more</p>
        </div>
      </div>
    </div>

    <template v-if="!$vuetify.breakpoint.smAndDown">
      <div class="breadcrumb-bar">
        <div class="breadcrumb-inner">
          <nuxt-link :to="{ name: 'index' }" class="breadcrumb-link">Home</nuxt-link>
          <span class="breadcrumb-sep">/</span>
          <nuxt-link :to="{ name: 'index-faq-articles', params: { articles: 'list' } }" class="breadcrumb-link">FAQ</nuxt-link>
          <template v-if="content && content.title">
            <span class="breadcrumb-sep">/</span>
            <span class="breadcrumb-current">{{ content.title }}</span>
          </template>
        </div>
      </div>

      <div class="container-box">
        <listMenu :list="list" @change="change" />
        <contentFaq v-if="content" :key="$route.params.articles" :content="content" />
        <div v-else class="content-card empty-state">
          <div class="card-body">
            <p class="empty-text">Select a topic from the menu to view the answer.</p>
          </div>
        </div>
      </div>
    </template>

    <template v-else>
      <div class="nav-header">
        <v-menu offset-y class="menu-box">
          <template #activator="{ on, attrs }">
            <div class="option" v-bind="attrs" v-on="on"><img class="img" src="/imgs/menu2.png" alt="menu-center" /></div>
          </template>
          <div class="center-menu">
            <p @click="menu">Menu</p>
            <p @click="goHone">Home</p>
          </div>
        </v-menu>
        <span class="mobile-page-label">FAQ</span>
      </div>
      <v-navigation-drawer v-model="drawer" absolute temporary>
        <listMenu :list="list" @change="change" />
      </v-navigation-drawer>
      <contentFaq v-if="content" :key="$route.params.articles" :content="content" />
      <LgoTop dom=".indexMobile" />
    </template>
  </div>
</template>

<script>
import listMenu from '@/components/Lfaq/listMenu.vue'
import contentFaq from '@/components/Lfaq/content.vue'
import LgoTop from '@/components/LgoTop/index.vue'
import { generateFaqHead } from '@/assets/utils/seo'

export default {
  name: 'faqArticles',
  components: {
    listMenu,
    contentFaq,
    LgoTop
  },
  validate({ params }) {
    return Boolean(params.articles)
  },
  async asyncData({ params, query, $api, error }) {
    try {
      let paramsInfo = params.articles
      const { data: list, cover } = await $api.home.getFaqList({ search: query.search || '' })
      if (list && list.length) {
        if (paramsInfo === 'list') {
          paramsInfo = list[0].id
        }
        const { data: content } = await $api.home.getFaqInfo({ question_id: paramsInfo })
        return {
          cover,
          list,
          content
        }
      } else {
        return {
          cover,
          list: []
        }
      }
    } catch (err) {
      return {
        cover: '',
        list: []
      }
    }
  },
  data() {
    return {
      drawer: false
    }
  },
  head() {
    if (this.$route.params.articles === 'list') {
      return generateFaqHead(null, this.$route.fullPath)
    }
    return generateFaqHead(this.content, this.$route.fullPath)
  },
  computed: {},
  watch: {
    '$route.params.articles': {
      handler(val) {
        if (this.$vuetify.breakpoint.smAndDown) {
          this.drawer = val === 'list'
        }
      },
      deep: true,
      immediate: true
    }
  },
  watchQuery: true,
  created() {},
  mounted() {},
  methods: {
    change(id) {
      this.$router.push({
        name: 'index-faq-articles',
        params: {
          articles: id
        }
      })
      if (this.$vuetify.breakpoint.smAndDown) {
        this.drawer = false
      }
    },
    goHone() {
      this.$router.replace({
        name: 'index'
      })
    },
    menu() {
      this.drawer = true
    }
  }
}
</script>

<style lang="scss" scoped>
.faq-page {
  background: #f7f8fa;
  min-height: 100vh;
}
.banner {
  position: relative;
  overflow: hidden;
  img {
    width: 100%;
    display: block;
  }
}
.banner-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.05) 0%, rgba(0, 0, 0, 0.35) 100%);
  display: flex;
  align-items: flex-end;
  justify-content: center;
  padding-bottom: 40px;
}
.banner-content {
  text-align: center;
  color: #fff;
}
.banner-title {
  font-size: 36px;
  font-weight: 700;
  margin: 0 0 8px;
  letter-spacing: -0.5px;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}
.banner-subtitle {
  font-size: 16px;
  margin: 0;
  opacity: 0.9;
  font-weight: 400;
  text-shadow: 0 1px 4px rgba(0, 0, 0, 0.15);
}
.breadcrumb-bar {
  max-width: 1200px;
  margin: 0 auto;
  padding: 16px 0;
}
.breadcrumb-inner {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
}
.breadcrumb-link {
  color: #6b7280;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.2s;
}
.breadcrumb-link:hover {
  color: #3067f2;
}
.breadcrumb-sep {
  color: #d1d5db;
}
.breadcrumb-current {
  color: #1a1a2e;
  font-weight: 600;
}
.container-box {
  display: flex;
  max-width: 1200px;
  margin: 0 auto 80px;
  align-items: flex-start;
}
.empty-state {
  min-height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.empty-text {
  color: #9ca3af;
  font-size: 15px;
  text-align: center;
}
</style>
<style lang="scss" scoped>
@media screen and (max-width: 960px) {
  .faq-page {
    background: #fff;
  }
  .banner {
    display: none;
  }
  .menu {
    position: absolute;
    left: 0;
    right: 0;
    z-index: 1;
    background: red;
  }
  .nav-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 54px;
    padding: 0 16px;
    background: #f2f2f2;
    position: sticky;
    top: 0;
    z-index: 10;
  }
  .mobile-page-label {
    font-size: 14px;
    font-weight: 600;
    color: #2b2e33;
  }
  ::v-deep .v-navigation-drawer {
    width: 100% !important;
  }
  .option {
    display: flex;
    align-items: center;
  }
  .img {
    height: 22px;
  }
  .center-menu {
    text-align: center;
    width: 150px;
    background: #fff;
    p {
      color: #2b2e33;
      font-size: 16px;
      margin-bottom: 0;
      padding: 10px 0;
    }
    p:first-child {
      border-bottom: 1px solid #dbdbdb;
    }
  }
}
</style>
